<template lang="pug">
  #all-packages-label-template.d-none
    PackageLabelTemplate(v-for="p in packages" :key="p.id" :context="p")
</template>

<script>
import { Printd } from 'printd'
import PackageLabelTemplate from './PackageLabelTemplate.vue'
import css from './css.js'

export default {
  components: {
    PackageLabelTemplate
  },
  data () {
    return {
      packages: []
    }
  },
  methods: {
    print (packages) {
      this.packages = []
      for (const p of packages) {
        let i = 1
        const max = p.bundleQuantity

        while (i <= max) {
          p.bundleNum = i
          p.bundleQuantity = max
          this.packages.push({ ...p, bundleNum: i })
          i++
        }
      }

      console.log(packages)
      this.$nextTick(() => {
        const d = new Printd()
        d.print(document.getElementById('all-packages-label-template'), [css])
      })
    }
  }
}
</script>
